import { relationshipConverter as _relationshipConverter } from '@griply/services';
import { Relationship } from '@griply/types';
import { FirestoreDataConverter } from 'firebase/firestore';

export const relationshipConverter =
  _relationshipConverter as unknown as FirestoreDataConverter<Relationship>;
